var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('b-button',{on:{"click":_vm.goToNotifications}},[_c('b-icon',{attrs:{"icon":"bell","size":"is-small"}})],1),_vm._v(" "),(_vm.newNotifications.length > 0)?_c('div',{staticClass:"red-dot"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }